module.exports = __webpack_public_path__ + "static/media/correct.e21bcc04.svg";